import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

const Index = () => {
  useEffect(() => {
    // Log when this component mounts to help with debugging
    console.log("Index component mounted, redirecting to dashboard");
    console.log("Environment check:", {
      VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL ? "Set" : "Not set",
      VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY ? "Set" : "Not set"
    });
  }, []);

  return <Navigate to="/dashboard" replace />;
};

export default Index;
